import React from "react";

import { Controller } from "react-hook-form";
import { MultiSelect } from "primereact/multiselect";
import { FloatLabel } from "primereact/floatlabel";

const MultipleSelect = ({
  name,
  control,
  label,
  rules,
  options,
  placeholder,
  onChange,
  disabled,
  emptyMessage,
  require,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <>
          <label htmlFor={field.name}></label>
          <FloatLabel className="w-100">
            <MultiSelect
              required={require}
              id={field.name}
              name={field.name}
              value={field.value}
              options={options}
              disabled={disabled}
              selectedItemsLabel="Itens Selecionados"
              onChange={(e) => {
                field.onChange(e.value);
                onChange && onChange(e.value);
              }}
              emptyMessage={emptyMessage || "Nenhuma informação encontrada."}
              optionLabel="name"
              placeholder={placeholder}
              maxSelectedLabels={5}
              className="w-100"
              style={{ height: "2.6rem" }}
            />
            <label htmlFor={field.name}>{label}</label>
          </FloatLabel>
          {fieldState.error && (
            <span className="p-error">{fieldState.error.message}</span>
          )}
        </>
      )}
    />
  );
};

export default MultipleSelect;
